import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectOneServiceProviderQueryItems } from '../../../../../redux/one-service-provider/selector';
import storePersist from '../../../../../redux/storePersist';
import { oneServiceProvider } from '../../../../../redux/one-service-provider/action';
import PageLoader from '../../../../../components/PageLoader';
import OnespComponent from '../components/onesp-component';


const ManagementOneServiceProvider= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const OnespItems = useSelector(selectOneServiceProviderQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
    const librariesItems = storePersist?.get("library")?.current;

  const [ selectedOnesp, setSelectedOnesp ] = useState<any>([])
    const [
      selectedAddress,
      setSelectedAddress
    ] = useState<any>({
  
      PrimaryAddress: {},
      
  
    })
 
  const fetchOnespQueryById= ()=>{
    
    dispatch(oneServiceProvider.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers/query`,entity:'oneServiceProvider',jsonData:{
    Records: [
      {   
              "Id": parmas?.id      
      }
    ]
  
  }})).then(()=>{
    setIsQuery(true)
  })

  }


  
 

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedOnesp({ ...selectedOnesp, [fields[0]]: value });
      setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  useEffect(
    () => {
     
      
      if (parmas?.id > 0) {
        fetchOnespQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }    
    
     
    },
    []
  )

  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedOnesp(OnespItems?.result?.items)
      }
    },
    [isQuery]
  )
  
  

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(oneServiceProvider.resetAction({ actionType: 'update' }))
      await dispatch(oneServiceProvider.update({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers`,
      entity:'oneServiceProvider',
      jsonData:{
          
    Records: [
      {
         ...selectedOnesp

      }
      
    ]
 
    }})).then(()=>{
      back()
    })

    }else{
      await dispatch(oneServiceProvider.resetAction({ actionType: 'create' }))
      await dispatch(oneServiceProvider.create({
        url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-service-providers`,
        entity:'oneServiceProvider',
        jsonData:{
          
      Records: [
        { 
            ...selectedOnesp
      }
      ]
    
    }})).then(()=>{
      back()
    })
    }
   
  }

  const back=()=>{
    navigate('/management/e-applications/onesp/one-service-provider')
  } 
    return (
      <>
        {isLoading ? <PageLoader /> :
        <OnespComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectedOnesp={selectedOnesp}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
          selectedAddress={selectedAddress}
          
  
          
        />  
    }
      </>
    )
    
    }
   
    export default ManagementOneServiceProvider;